import React, { Component } from "react";
import Switch from "react-switch";
import styles from "../common/Toggle.scss";
 
class SceUpdateToggle extends Component {
 constructor(props) {
 super(props);
 this.handleChange = this.handleChange.bind(this);
 }
handleChange =checked =>{
    checked ? window.aUtils.sendAAEvent("ToggleOn","sceUpdates") : window.aUtils.sendAAEvent("ToggleOff","sceUpdates") ;
    this.props.handleMarket(checked);
}


render() {
 return (
 
 <label htmlFor="sceUpdate">
 
 <Switch
 checked={this.props.isToggleOn}
 onChange={this.handleChange}
 handleDiameter={22}
 height={30}
 width={70}
 borderRadius={15}
 onColor="#64A000"
 offColor="#E9EAEE"
 
 
uncheckedIcon={
    <div className={styles.Off}>Off</div>
   }
checkedIcon={<div className={styles.On}>On</div>
   }
 
 className="react-switch"
 id="sceUpdate"
 />
</label>
 
 );
 }
}
export default SceUpdateToggle;
